<div class="densest">
  <div>
    <label class="dropdown-label" [for]="id"
      >{{ label }}<span *ngIf="required"> *</span></label
    >
  </div>
  <mat-form-field appearance="outline" class="dropdown-form-field">
    <mat-icon
      class="dropdown-icon"
      matSuffix
      *ngIf="control.status == 'INVALID' && control.touched"
      >error_outline</mat-icon
    >
    <mat-select [formControl]="control" [id]="id" [attr.aria-required]="required || null" *ngIf="!isCustom">
      <mat-option
        *ngFor="let datum of data; trackBy: identify"
        [value]="datum.value"
        >{{ datum.label }}</mat-option
      >
    </mat-select>
    <mat-select [formControl]="control" [id]="id" [attr.aria-required]="required || null" *ngIf="isCustom">
      <mat-option
        *ngFor="let datum of data; trackBy: identify"
        [value]="datum.levelId"
        >{{ datum.name }}</mat-option
      >
    </mat-select>
    <mat-error>{{ errorText }}</mat-error>
  </mat-form-field>
</div>
